import React from 'react';
import PropTypes from "prop-types";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import {accessConstants, authUtils, filterConstants} from "mindsets-js-sdk";

const NumberLessonsJoinedAsCoTeacher = function ({user}) {
    const me = useSelector(state => state.me);

    if (user.co_classes_count > 0 && authUtils.iCan(me, [accessConstants.PERMISSION_CAN_SEE_ALL_LESSONS])) {
        return (
            <Link
                to={`/lessons?column~0=co_teacher_id&expression~0=${filterConstants.EXPRESSION_EQUAL}&value~0=${user.id}`}
                data-bs-toggle="tooltip"
                data-placement="top"
                title="Show all the Classes the user joined as a Co-Teacher"
            >{user.co_classes_count}</Link>
        );
    } else {
        return user.co_classes_count;
    }
}

NumberLessonsJoinedAsCoTeacher.propTypes = {
    user: PropTypes.shape({
        id: PropTypes.number.isRequired,
        co_classes_count: PropTypes.number.isRequired
    }).isRequired
};

export default NumberLessonsJoinedAsCoTeacher;
